import Vue from 'vue'
import App from './App'


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import VueRouter from 'vue-router'
import store from './store'
import i18n from './i18n'
import Vuex from 'vuex'
import 'font-awesome/css/font-awesome.min.css'

import router from './router'

import http from "./http"
import mixin from './mixin'
import './style/style.scss';
import qs from 'qs'
import util from './util'

import asideMenu from './component/asideMenu.vue'

Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)

Vue.component('aside-menu',asideMenu)

window.$qs = qs;
window.$http = http;
window.$util=util;
window.$mixin = mixin;

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js